module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.17.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.18.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.19.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.20.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.21.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.21.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.21.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.21.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.21.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.21.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.21.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.21.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.22.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.14.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.15.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.4.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.4.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.4.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.0.0.box.128.876.1039.1014.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT8.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.8.0.0.box.128.876.1039.427.q.60"
    }
  }, [_vm._v("L‌ong ago in China there lived a stone carver named Chan Lo. Chan Lo spent his days carving birds and deer and water buffalo from the colored stones he found near the river.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT8.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "101%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.0.1.box.128.1335.1038.146.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.4.1.0"
    }
  }), _vm._v("\"How do you know what to carve?\" his young apprentice asked.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT8.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "101%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.0.2.box.128.1499.1039.213.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.4.2.0"
    }
  }), _vm._v("\"I always listen to the stone,\" replied Chan Lo. \"The stone tells me what it wants to be.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT8.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "101%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.0.3.box.129.1744.1038.146.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.4.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.7.0.0"
    }
  }), _vm._v("People came from near"), _c('a', {
    attrs: {
      "id": "GBS.PP10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.2.0.0"
    }
  }), _vm._v(" and far to buy Chan "), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.3.0.0"
    }
  }), _vm._v("Lo's carvings.")]), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.4.0.0"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.4.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.4.0.0"
    }
  }), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.8.1.0.box.1262.414.1512.1798.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0008.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.5.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.9.0.0.box.130.534.2760.1666.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.6.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0009.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.6.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.10.0.0.box.1033.316.1800.1778.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP12.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0010.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP12.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP12.w.0.0.0.2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP12.w.1.0.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.1.0.box.262.1599.747.490.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT10.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.10.1.0.box.262.1599.747.490.q.70"
    }
  }, [_vm._v("So it happened that when the Great Emperor of All China was given a perfect piece of green-and-white jade"), _c('a', {
    attrs: {
      "id": "GBS.PP12.w.2.0.0"
    }
  }), _vm._v(" stone, one of the ad"), _c('a', {
    attrs: {
      "id": "GBS.PP12.w.3.0.0"
    }
  }), _vm._v("visers in the Celesti"), _c('a', {
    attrs: {
      "id": "GBS.PP12.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP12.w.5.0.0"
    }
  }), _vm._v("al Palace thought of Chan Lo.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT10.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.1.box.262.1599.747.490.q.101"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.11.0.0.box.96.404.2825.1810.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13.w.2.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0011.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.2.1.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.12.0.0.box.21.425.1086.1758.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13.w.2.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0012.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.2.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.1.0.box.1119.572.944.647.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT12.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.12.1.0.box.1119.572.944.197.q.70"
    }
  }, [_vm._v("The humble stone carver was brought before the Great Emperor of All China.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT12.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.1.box.1179.798.596.58.q.70"
    }
  }, [_vm._v("Chan Lo bowed deeply.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT12.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.2.box.1119.873.944.195.q.60"
    }
  }, [_vm._v("\"I want you to carve a dragon,\" the emperor commanded, \"a dragon of wind and fire.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT12.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.3.box.1121.1099.938.120.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.6.0.0"
    }
  }), _vm._v("\"I will do my be"), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.7.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.4.0.0"
    }
  }), _vm._v("st to please you,\""), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.7.0.0"
    }
  }), _vm._v(" Chan Lo said.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.7.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT12.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.4.box.1119.572.944.647.q.101"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.12.2.0.box.1628.658.1204.1488.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0013.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.3.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.13.0.0.box.46.484.2875.1622.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0014.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.5.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.14.0.0.box.265.504.2509.1546.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.5.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0015.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.5.1.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.0.0.box.153.484.1042.1458.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT15.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.0.box.214.484.565.58.q.70"
    }
  }, [_vm._v("He spoke to the stone:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT15.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.15.0.1.box.155.592.1040.281.q.60"
    }
  }, [_vm._v("\"Here I stand, O Noble Stone, to carve a creature of your own. Whisper signs and sounds from rock that I, your servant, may unlock.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT15.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.2.box.154.928.1041.269.q.60"
    }
  }, [_vm._v("Chan Lo bent down and put his ear to the stone. From deep inside came a gentle sound. \"Pah-tah,\" it went. \"Pah-tah, pah"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tahr ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT15.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.3.box.156.1226.1038.120.q.70"
    }
  }, [_vm._v("\"Do dragons make that sound?\" Chan Lo wondered.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT15.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.4.box.154.1375.1041.209.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.5.2.0"
    }
  }), _vm._v("Perhaps the dragon's tail splashing in the ocean says \"Pah-tah, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pah-tah\" ")]), _vm._v("he thought. But he was not sure.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT15.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.5.box.153.1600.1041.194.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.5.3.0"
    }
  }), _vm._v("That evening Chan Lo ate his rice cakes and sipped his tea. He "), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.7.0.0"
    }
  }), _vm._v("thought about dragons.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT15.w.0.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.6.box.154.1823.1040.119.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.9.0.0"
    }
  }), _vm._v("In his dreams he heard \"Pah-tah, pah"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.10.0.0"
    }
  }), _vm._v("tabr ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.15.1.0.box.1282.368.1526.1740.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0016.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_column",
    attrs: {
      "id": "block.16.0.0.box.146.475.950.1465.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT16.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_column",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.0.0.box.149.475.947.207.q.70"
    }
  }, [_vm._v("The next morning Chan Lo went to the garden. The stone was springwater-green in the morning light.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT16.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_column",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.0.1.box.209.698.354.46.q.80"
    }
  }, [_vm._v("Chan Lo said:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT16.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_column",
    attrs: {
      "id": "para.16.0.2.box.149.806.947.283.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.2.0.0"
    }
  }), _vm._v("\"Here I stand, O Noble Stone, to carve a creature of your own. Whisper signs and sounds from rock that I, your servant, may unlock.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT16.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_column",
    attrs: {
      "id": "para.16.0.3.box.148.1139.946.268.q.60"
    }
  }, [_vm._v("Chan Lo put his ear to the green-andwhite jade and listened. Softly, the sounds came. \"Bub—bubb—bubble,\" he heard. \"Bub-bubb-bubble.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT16.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_column",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.0.4.box.148.1436.945.282.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.2.1.0"
    }
  }), _vm._v("\"Do dragons make that sound?\" Chan Lo asked himself. \"Perhaps a dragon rising from the wild waves blows bubbles through his nostrils.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT16.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_column",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.0.5.box.146.1734.946.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.2.2.0"
    }
  }), _vm._v("But these were not mighty dragon bubbles coming from the rock. They were gentle, laz"), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.3.0.0"
    }
  }), _vm._v("y, playful sounds.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_column",
    attrs: {
      "id": "block.16.1.0.box.1637.475.945.356.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT16.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_column",
    attrs: {
      "id": "para.16.1.0.box.1638.475.944.133.q.60"
    }
  }, [_vm._v("Chan Lo's heart grew heavy, for he had not heard the emperor's dragon.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT16.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_column",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.1.box.1637.624.945.207.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.5.0.0"
    }
  }), _vm._v("That evening, when Chan Lo ate his rice cakes and sipped his tea, he tried again to think about dragons.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.16.2.0.box.1150.936.1644.1134.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP18.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0017.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP18.w.1.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.17.0.0.box.70.354.1532.1380.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP18.w.1.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0018.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP18.w.1.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.1.0.box.1718.454.949.1464.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT17.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "left",
      "clear": "both"
    },
    attrs: {
      "id": "para.17.1.0.box.1723.454.943.194.q.70"
    }
  }, [_vm._v("But when he went to bed, he heard the sound of \"Bub-bubb-bubble\" in his dreams.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "left"
    },
    attrs: {
      "id": "para.17.1.1.box.1722.677.945.283.q.70"
    }
  }, [_vm._v("In the middle of the night, Chan Lo awoke. He walked into the moonlit garden. The stone shone silvery-green in the moonlight.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT17.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.17.1.2.box.1781.976.757.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP18.w.1.2.0"
    }
  }), _vm._v("He would listen one last time.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT17.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.3.box.1721.1083.945.282.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP18.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP18.w.3.0.0"
    }
  }), _vm._v("\"Here I stand, O Noble Stone, to carve a creature of your own. Whisper signs and sounds from rock that I, your servant, may unlock.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT17.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.4.box.1780.1414.692.58.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP18.w.3.1.0"
    }
  }), _vm._v("He put his ear to the stone.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT17.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "left"
    },
    attrs: {
      "id": "para.17.1.5.box.1780.1489.181.45.q.70"
    }
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT17.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "left"
    },
    attrs: {
      "id": "para.17.1.6.box.1718.1562.947.282.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP18.w.3.2.0"
    }
  }), _vm._v("Chan Lo ran his hands over the jade. His fingers felt tiny ridges. \"S-s-s-ah, S-s-s-s-s-ah, S-s-s-s-s-s-sah,\" went his fingers over the stone.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT17.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.7.box.1775.1860.620.58.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP18.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP18.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.1.0.0"
    }
  }), _vm._v("Do dragons have ridges?")]), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.2.1.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.2.3.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.3.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.4.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP20.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP20.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP20.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP20.w.2.0.0"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP20.w.3.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.18.0.0.box.197.461.2620.1730.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP20.w.4.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP20.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0019.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP20.w.5.0.0.1"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP20.w.6.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP21.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP21.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP21.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP21.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP21.w.4.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.19.0.0.box.38.372.2826.1766.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP21.w.4.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0020.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP21.w.4.1.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.20.0.0.box.92.412.2725.1120.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP21.w.4.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0021.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP21.w.4.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.1.0.box.1458.1578.1093.566.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT20.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.0.box.1458.1578.1092.206.q.70"
    }
  }, [_vm._v("Chan Lo entered the Great Hall where the three advisers sat waiting for the Great Emperor of All China.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.1.box.1458.1799.1092.122.q.70"
    }
  }, [_vm._v("He placed the jade stone on the table in the center of the room.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.2.box.1458.1950.1093.194.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.0.0.0"
    }
  }), _vm._v("Soon the emperor'"), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.1.0.0"
    }
  }), _vm._v("s advisers grew curio"), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.4.0.0"
    }
  }), _vm._v("us. They scurried to "), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.6.0.0"
    }
  }), _vm._v("the jade stone and pe"), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.7.0.0"
    }
  }), _vm._v("eked under the cloth.")]), _c('a', {
    attrs: {
      "id": "GBS.PP22.w.8.0.0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP22.w.8.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP23.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.21.0.0.box.60.378.2857.1806.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP23.w.1.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0022.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP23.w.1.1.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.22.0.0.box.0.424.1626.1705.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP23.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0023.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP23.w.1.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.1.0.box.1582.505.1235.1041.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.0.box.1642.505.1022.59.q.70"
    }
  }, [_vm._v("\"No dragon,\" whispered the first, softly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.1.box.1642.579.1030.48.q.80"
    }
  }, [_vm._v("\"NO DRAGON!\" exclaimed the second.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.2.box.1642.655.926.46.q.70"
    }
  }, [_vm._v("\"NO DRAGON!\" shouted the third.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.3.box.1583.730.1192.120.q.70"
    }
  }, [_vm._v("At that moment, the emperor himself was carried into the Great Hall.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.4.box.1582.879.1193.133.q.70"
    }
  }, [_vm._v("\"Show me my dragon of wind and fire!\" the emperor ordered.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.5.box.1661.1025.946.58.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP23.w.1.3.0"
    }
  }), _vm._v("The advisers whisked the cloth away.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.6.box.1648.1100.1160.58.q.60"
    }
  }, [_vm._v("\"This is not my dragon,\" the emperor roared,")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.7.box.1643.1175.1166.60.q.70"
    }
  }, [_vm._v("his eyes dark with anger, his voice rolling like")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.8.box.1644.1252.359.45.q.80"
    }
  }, [_vm._v("black thunder.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.9.box.1647.1330.864.49.q.70"
    }
  }, [_vm._v("\"PUNISH HIM! PUNISH HIM!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT22.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.22.1.10.box.1645.1416.1172.130.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP23.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP23.w.2.0.0"
    }
  }), _vm._v("  PUNISH HIM!\" t"), _c('a', {
    attrs: {
      "id": "GBS.PP23.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP23.w.4.0.0"
    }
  }), _vm._v("he three advisers chanted.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.0.0.box.584.453.1788.581.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT23.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.0.0.box.584.453.1787.271.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP24.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP24.w.1.0.0"
    }
  }), _vm._v("\"Oh mighty emperor, there is no dragon of wind and fire,\" Chan Lo said, his knees shaking like ginkgo leaves in the wind. \"I did not hear it. I heard these three carp fish swimming playfully in the reeds in the pool of the Celestial Palace.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP24.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP24.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT23.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.0.1.box.584.752.1788.121.q.40"
    }
  }, [_vm._v("\"HEAR IT? You did not HEAR it!\" The emperor's words burned Chan Lo's ears. \"TAKE HIM AWAY!\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT23.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.0.2.box.585.901.1787.133.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP24.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP24.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP24.w.3.0.0"
    }
  }), _vm._v("Chan Lo was lifted by"), _c('a', {
    attrs: {
      "id": "GBS.PP24.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP25.w.0.0.0"
    }
  }), _vm._v(" two palace guards, t"), _c('a', {
    attrs: {
      "id": "GBS.PP25.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP25.w.0.2.0"
    }
  }), _vm._v("hen dragged down many"), _c('a', {
    attrs: {
      "id": "GBS.PP25.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP25.w.1.0.0"
    }
  }), _vm._v(" flights of stairs an"), _c('a', {
    attrs: {
      "id": "GBS.PP25.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP25.w.3.0.0"
    }
  }), _vm._v("d thrown into a black"), _c('a', {
    attrs: {
      "id": "GBS.PP25.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP25.w.5.0.0"
    }
  }), _vm._v(" prison cell.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.23.1.0.box.84.1064.2234.1118.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP26.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP26.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0024.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP26.w.1.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP26.w.1.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP26.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.24.0.0.box.0.476.2872.1726.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP26.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0025.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP26.w.1.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.0.0.box.635.440.1788.358.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT25.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.0.0.box.635.440.1787.134.q.70"
    }
  }, [_vm._v("That night, the emperor dreamed of fish playfully slapping their tails in green water. \"Pah-tah, pah-tah.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT25.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.0.1.box.635.591.1788.131.q.60"
    }
  }, [_vm._v("In the morning the emperor's advisers asked, \"What punishment have you chosen?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT25.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.0.2.box.694.739.1354.59.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP26.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP26.w.3.0.0"
    }
  }), _vm._v("\"My dreams have "), _c('a', {
    attrs: {
      "id": "GBS.PP26.w.4.0.0"
    }
  }), _vm._v("not yet decided,\""), _c('a', {
    attrs: {
      "id": "GBS.PP26.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP26.w.6.0.0"
    }
  }), _vm._v(" said the emperor.")]), _c('a', {
    attrs: {
      "id": "GBS.PP26.w.7.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.25.1.0.box.78.799.2762.1414.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP27.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0026.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP27.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.0.0.box.554.482.1789.358.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT26.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.0.box.554.482.1788.134.q.50"
    }
  }, [_vm._v("The next night the emperor dreamed of fish gliding smoothly through deep, clear water. \"Bub-bubb—bubble, bub—bubb-bubble.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT26.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.1.box.554.632.1789.133.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP27.w.0.1.0"
    }
  }), _vm._v("In the morning the emperor's advisers again asked him, \"What punishment have your dreams chosen?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT26.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.2.box.613.782.1372.58.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP27.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP27.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP27.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP27.w.3.0.0"
    }
  }), _vm._v("\"My dreams have "), _c('a', {
    attrs: {
      "id": "GBS.PP27.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP27.w.5.0.0"
    }
  }), _vm._v("still not decided,\""), _c('a', {
    attrs: {
      "id": "GBS.PP27.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP27.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP28.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP28.w.1.0.0"
    }
  }), _vm._v(" said the emperor.")]), _c('a', {
    attrs: {
      "id": "GBS.PP28.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP28.w.3.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP28.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP28.w.5.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP28.w.5.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP28.w.6.0.0"
    }
  }), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.26.1.0.box.488.852.2168.1264.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP28.w.7.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP29.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP29.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0027.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP29.w.1.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.27.0.0.box.54.0.2802.2389.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP29.w.1.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0028.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP29.w.1.1.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.28.0.0.box.0.364.1688.1544.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP29.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0029.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP29.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.1.0.box.1778.508.947.1165.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT28.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.28.1.0.box.1780.508.945.421.q.60"
    }
  }, [_vm._v("On the third night, the emperor groaned and tossed in his sleep, but he did not dream. He awoke in the darkest hour of the night. A strange sound filled the room. \"S-s-s-ah, S-s-s-s-s-ah, S-s-s-s-s-s-s-ah.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT28.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.1.box.1778.957.946.716.q.60"
    }
  }, [_vm._v("The emperor got out of bed and went toward the sound. He hurried down the corridors, through the Great Hall, and out into the moonlit garden. There, by the reflecting pool, was the jade stone. Next to it stood the stone carver'"), _c('a', {
    attrs: {
      "id": "GBS.PP29.w.3.0.0"
    }
  }), _vm._v("s apprentice, running his fingers down the scales of the three carp fish. \"S-s-s-ah, S-s-s-s-s-ah, S-s-s-s-s-ss-ah.\"")]), _c('a', {
    attrs: {
      "id": "GBS.PP29.w.4.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP30"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP30.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP30.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP30.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP30.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.0.0.box.581.428.1785.345.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT29.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.0.0.box.581.428.1785.209.q.70"
    }
  }, [_vm._v("The shining scales of the jade carp glowed in the moonlight. The fishes' slippery bodies were reflected in the pool. They seemed ready to flick their tails and swim among the reeds.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT29.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.0.1.box.581.653.1785.120.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP30.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP30.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP30.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP30.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP30.w.6.0.0"
    }
  }), _vm._v("The emperor sat near "), _c('a', {
    attrs: {
      "id": "GBS.PP31"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP31.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP31.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP31.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP31.w.3.0.0"
    }
  }), _vm._v("the pool, gazing at t"), _c('a', {
    attrs: {
      "id": "GBS.PP31.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP31.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP31.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP31.w.7.0.0"
    }
  }), _vm._v("he jade stone until h"), _c('a', {
    attrs: {
      "id": "GBS.PP31.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.4.0.0"
    }
  }), _vm._v("is advisers found him"), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.8.0.0"
    }
  }), _vm._v(" at sunrise.")]), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.10.0.0"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP32.w.10.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP33"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP33.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP33.w.1.0.0"
    }
  }), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.29.1.0.box.188.802.2638.1324.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP33.w.1.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0030.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP33.w.1.1.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.30.0.0.box.276.472.2368.1726.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP33.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0031.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP33.w.1.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.31.0.0.box.126.404.2586.1780.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP33.w.1.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0032.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP33.w.1.3.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.32.0.0.box.208.676.1354.1314.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP33.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0033.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP33.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.1.0.box.1718.506.1096.1402.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT32.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "clear": "both"
    },
    attrs: {
      "id": "para.32.1.0.box.1721.506.1093.209.q.70"
    }
  }, [_vm._v("Chan Lo bowed deeply before the Great Emperor of All China, ready to receive his terrible punishment.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT32.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.1.box.1719.732.1095.569.q.60"
    }
  }, [_vm._v("\"You have disobeyed me, Chan Lo, but you are a brave man to defy the Great Emperor of All China,\" said the emperor. \"You have carved the creatures that were in the stone. I, too, have heard them. These three carp fish are dearer to me than any dragon of wind and fire. What reward would you have?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT32.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.2.box.1719.1329.1092.270.q.50"
    }
  }, [_vm._v("Chan Lo bowed lower still. \"Great Emperor, your happiness with my work is my reward. I wish only to return to my village and carve what I hear.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT32.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.3.box.1718.1629.1093.279.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP33.w.3.0.0"
    }
  }), _vm._v("\"You will carve "), _c('a', {
    attrs: {
      "id": "GBS.PP34"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP34.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP34.w.1.0.0"
    }
  }), _vm._v("what you hear,\" "), _c('a', {
    attrs: {
      "id": "GBS.PP34.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP34.w.3.0.0"
    }
  }), _vm._v("said the emperor, \""), _c('a', {
    attrs: {
      "id": "GBS.PP34.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP35"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.0.0.0"
    }
  }), _vm._v("and return to your vi"), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.3.0.0"
    }
  }), _vm._v("llage in a way befitt"), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.6.0.0"
    }
  }), _vm._v("ing the Master Carver"), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.8.0.0"
    }
  }), _vm._v(" to the Great Emperor"), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP35.w.10.0.0"
    }
  }), _vm._v(" of All China!\"")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP36.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP36.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP36.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP36.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP36.w.4.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP36.w.4.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP36.w.5.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT33"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.33.0.0.box.260.464.2653.1464.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP36.w.6.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic][subsumed]",
      "src": "data/content-0034.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP36.w.6.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.34.0.0.box.0.532.2702.1522.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP36.w.7.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0035.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP36.w.7.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.35.0.0.box.138.232.1870.752.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP37"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP37.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP37.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0036.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP37.w.1.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.35.1.0.box.752.1098.1488.694.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT35.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "clear": "both"
    },
    attrs: {
      "id": "para.35.1.0.box.752.1098.1488.586.q.60"
    }
  }, [_vm._v("In 1917, the merchant A.L. Gump was in Beijing, China, buying jade for his San Francisco store, when a Mandarin told him a story about a jade carver and an emperor. Years later, Mr. Gump's son Richard described the story in his book, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Jade, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stone ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Heaven. ")]), _vm._v("When I heard the story, I could not forget it. I decided to expand it into a picture book for children. Like Chan Lo's sculpture, it took a year and a day (or maybe a little longer).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT35.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.35.1.1.box.1295.1735.401.57.q.70"
    }
  }, [_vm._v("Caryn Yacowitz")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.2.0.box.756.1878.1486.324.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT35.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.35.2.0.box.756.1878.1486.207.q.70"
    }
  }, [_vm._v("The art for each picture consists of an ink and watercolor painting prepared on handmade rice paper. I tried to evoke the look of ancient hand-colored oriental wood-block prints.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT35.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.35.2.1.box.1313.2143.366.59.q.80"
    }
  }, [_vm._v("Ju-Hong Chen")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.36.0.0.box.1960.464.292.416.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP37.w.1.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0037.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP37.w.1.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.1.0.box.1955.463.906.1238.q.99"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT36.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "clear": "right"
    },
    attrs: {
      "id": "para.36.1.0.box.1955.463.905.905.q.95"
    }
  }, [_vm._v("Author Caryn Yacowitz lives in Palo Alto, California. She has published eleven children's books, including a series of books on Native Americans, and her poetry and plays have appeared in several anthologies. She holds a master of arts degree in creative writing from San Francisco State University and an undergraduate degree in history/political science from Rutgers .University. Ms. Yacowitz teaches writing at several colleges and universities in northern California. Her picture book "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pumpkin ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Fiesta ")]), _vm._v("was named to the California Collections in 2005.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT36.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.1.box.1967.1385.894.316.q.99"
    }
  }, [_vm._v("Illustrator, designer, and painter Ju-Hong Chen was born in Shanghai, China. Since moving to America in 1982, he has illustrated a number of children's books. He lives in Beaverton, Oregon, with his wife and daughter.")]), _c('a', {
    attrs: {
      "id": "GBS.PP38"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP38.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP38.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP38.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP38.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP38.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP38.w.3.2.0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP38.w.3.2.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP38.w.3.2.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PT37"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP38.w.3.2.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 37",
      "src": "data/content-0038.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP38.w.3.2.0.4"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP38.w.3.2.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c1db172","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0039.vue
// module id = 57
// module chunks = 0